import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import InsumoRecord from '@components/InsumoRecord/InsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';

/**
 * Componente para tela de nematicida
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function Nematicidas(props) {
  useEffect(() => {
    const title = 'nematicidas.nematicidas';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <InsumoRecord
      chipData={props.chipData}
      infoUsuario={props.infoUsuario}
      insumoEnum={Insumo.NEMATICIDA}
      insumoURL='nematicidas'
      viewKey='nematicidas'
      deleteMessageSucess={formatMessage(
        'nematicidas.nematicidasRemovidoComSucesso'
      )}
      mensagemFalhaDeletar={formatMessage('nematicidas.falhaAoExcluirNematicidas')}
      mensagemDelete={formatMessage('nematicidas.desejaExcluir')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info,
  chipData: state.chips.chipData.filter(date => {
    return date.id === 'nematicidas';
  })[0].content
});

export default connect(mapStateToProps)(Nematicidas);
